import * as React from "react";
import api from "../../../api";
import { convertPascalCaseToWords, Expiry } from "../../../core";
import { LeadRequirement } from "../../../core/api/models/requirement";

interface IBreadCrumbProps {
  invoiceLockExpiry?: Expiry;
  configuration: LeadRequirement;
  requirementId: string;
}

const BreadCrumb: React.FunctionComponent<IBreadCrumbProps> = (props) => {
  const { configuration, requirementId } = props;

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb font-lg">
        <li className="breadcrumb-item font-weight-semibold">
          <span className="requirement-title">
            {requirementId
              ? `${
                  configuration?.cityDetails?.cityName
                },${configuration?.microMarketDetails
                  ?.map((x) => x.cityZoneName)
                  ?.join()}`
              : "New Configuration"}
          </span>
          {/* <span className="ml-3 mr-2 requirement-title">
            {" - "}V{configuration?.versionNumber}
          </span> */}
          {/* <span
            className={`bg-white font-sm px-2 py-1 requirement-title tag--${configuration?.status}`}
          >
            {convertPascalCaseToWords(
              configuration?.status === "pending"
                ? "Pending Approval"
                : configuration?.status || ""
            )}
          </span> */}
          <div className="d-block">
            {(configuration?.propertiesCount || 0) > 0 && (
              <span className="font-sm text-muted">
                {configuration?.propertiesCount} properties{", "}
              </span>
            )}
            {(configuration?.projectsCount || 0) > 0 && (
              <span className="font-sm text-muted">
                {configuration?.projectsCount} projects
              </span>
            )}
          </div>
        </li>
      </ol>
    </nav>
  );
};

export default BreadCrumb;
